import PropTypes from 'prop-types';

import { FeatureService } from '@spotahome/ui-library';

import ListingTagContainer from './ListingTagContainer';
import ListingTitle from './ListingTitle';

import './ListingDetailsFeatures.scss';

const formatFeatures = features => {
  const parsedFeatures = Object.entries(features).reduce((acc, current, i) => {
    const [key, value] = current;
    return {
      ...acc,
      [key]: {
        value,
        order: i
      }
    };
  }, {});
  return FeatureService.getFeaturesAsList(parsedFeatures);
};

const ListingDetailsFeatures = ({ title, features }) => (
  <div className="listing-features">
    <ListingTitle role="tertiary">{title}</ListingTitle>
    <ListingTagContainer
      tagList={formatFeatures(features)}
      hasBackground={false}
    />
  </div>
);

ListingDetailsFeatures.propTypes = {
  title: PropTypes.string.isRequired,
  features: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired
};

export default ListingDetailsFeatures;
